import React, { Component } from 'react';
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../utils/withRouter";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { connect } from "react-redux";
import { toastError, countryActionId, cityActionId, industryActionId, stateActionId, downloadReport, toastSuccess, sessionExpireMessage, tokenInavlidMessage } from '../../../utils/constants'
import { fill_action } from '../../../actions/fillCombo_action'
import Pagination from "../../../utils/pagination";
import Header from '../../../common_components/Header';
import { get_proformaList_action, proformaInvoiceRpt_action, share_proforma_action } from '../../../actions/adminAction/proforma_action';
import moment from 'moment';
import Loader from '../../../utils/Loader';

class proformaList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false, isFilterShow: false,
            isOtherPreName: false,
            MemberID: '', currentPage: 1,
            recordsPerPage: 10, proformaList: [],
            ProformaInvoiceDate: '', ProformaInvoiceNo: '', CompanyName: '',
            FullAccess: false, ReadAccess: false, WriteAccess: false, UpdateAccess: false, DeleteAccess: false, DownloadAccess: false, Is_SpecialAccess: false, SendAccess: false
        }
        this.updateItem = this.updateItem.bind(this);
        this.updateRecordsPerPage = this.updateRecordsPerPage.bind(this);

    }
    componentDidMount() {
        if (JSON.parse(sessionStorage.getItem("loginDataSS")) == null) {
            setTimeout(() => {
                this.props.navigate('/');
            }, 200);
            return;
        }
        const loginAccessList = JSON.parse(sessionStorage.getItem('loginAccesslist')) || [];
        const proformaListModule = loginAccessList.find(module => module.ModuleName === "Proforma List");

        if (proformaListModule) {
            const { FullAccess, ReadAccess, WriteAccess, UpdateAccess, DeleteAccess, DownloadAccess, Is_SpecialAccess, SendAccess } = proformaListModule;

            if (!FullAccess && !ReadAccess) {
                this.props.navigate('/login'); // Navigate to login if no access
            } else {
                this.setState({
                    FullAccess: !!FullAccess,
                    ReadAccess: !!ReadAccess,
                    WriteAccess: !!WriteAccess,
                    UpdateAccess: !!UpdateAccess,
                    DeleteAccess: !!DeleteAccess,
                    DownloadAccess: !!DownloadAccess,
                    Is_SpecialAccess: !!Is_SpecialAccess,
                    SendAccess: !!SendAccess
                });

                if (FullAccess) {
                    this.setState({
                        ReadAccess: true,
                        WriteAccess: true,
                        UpdateAccess: true,
                        DeleteAccess: true,
                        DownloadAccess: true,
                        Is_SpecialAccess: true,
                        SendAccess: true
                    });
                }
            }
        } else {
            this.props.navigate('/login');
        }

        if (loginAccessList.length) {
            window.scrollTo(0, 0);
            this.getFillList(countryActionId, '', '', '', '').then(() => {
                this.getFillList(industryActionId, '', '', '', '').then(() => {
                    this.getProformaList();
                });
            });
        }
    }


    getFillList(actionID, ModuleID, KeyValue, Value, UserID) {
        this.setState({ isLoading: true })
        return new Promise((resolve, reject) => {
            this.props
                .fill_action(actionID, ModuleID, KeyValue, Value, UserID)
                .then((data) => {
                    if (data.error != 1) {
                        if (actionID === countryActionId) {
                            this.setState({ countryList: data.data })
                            resolve(true)
                        }
                        else if (actionID === stateActionId) {
                            data.data.length > 0 && this.setState({
                                stateList: data.data,
                                tempStateList: data.data,
                            })
                            resolve(true)
                        }
                        else if (actionID === cityActionId) {
                            data.data.length > 0 && this.setState({
                                cityList: data.data,
                                tempCityList: data.data,
                            })
                            resolve(true)
                        }
                        else if (actionID === industryActionId) {
                            this.setState({
                                industryList: data.data,
                                // tempCityList: data.data,
                            })
                            resolve(true)
                        }
                    }
                })
        })
    }
    onProformaDownload(E, id) {
        this.setState({ isLoading: true })
        this.props.proformaInvoiceRpt_action(id)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false })
                    console.log("Proforma Pdf Download", data)
                    var url = `${downloadReport}?SessionIdentifier=${data}&Export=true`;
                    const win = window.location.replace(url, '_blank');
                    if (win != null) {
                        win.focus();
                    }
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })

    }
    getProformaList() {
        const { isLoading, CompanyName, ProformaInvoiceDate, ProformaInvoiceNo } = this.state
        this.setState({ isLoading: true })
        this.props
            .get_proformaList_action(CompanyName, ProformaInvoiceDate, ProformaInvoiceNo)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ proformaList: data.data });
                    setTimeout(() => {
                        this.setState({ isLoading: false });
                    }, 500);
                } else {
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear();
                        this.props.navigate("/");
                        setTimeout(() => {
                            toastError(data.msg);
                        }, 2000);
                    } else {
                        toastError(data.data);
                    }
                    this.setState({ isLoading: false })
                    toastError(data.data.ErrorMsg);
                }
            }).catch((e) => {
                console.log(e);
                this.setState({ isLoading: false });
            });
    }
    clearFilter() {
        this.setState({ CompanyName: '', ProformaInvoiceDate: '', ProformaInvoiceNo: '' }, () => this.getProformaList())
    }
    navigateUserView() {
        this.props.navigate('/user_details')
    }
    updateItem = (item) => {
        this.setState({ currentPage: item });
    };
    updateRecordsPerPage = (count) => {
        this.setState({ recordsPerPage: count, currentPage: 1 }, () => window.scrollTo(0, 0));
    };
    proformaRecord(proformaList) {
        const { ReadAccess, WriteAccess, UpdateAccess, DeleteAccess, DownloadAccess, SendAccess, Is_SpecialAccess } = this.state
        return (
            <table className="table table-bordered table-striped mg-b-0">
                <thead>
                    <tr>
                        <th>Proforma Invoice No</th>
                        <th>Company Name</th>
                        <th>Proforma Date</th>
                        <th>Service</th>
                        <th>Taxable Amount</th>
                        <th>Tax Type</th>
                        <th>CGST</th>
                        <th>SGST</th>
                        <th>IGST</th>
                        <th>Total Payable</th>
                        <th>Outstanding</th>
                        <th className="text-right" style={{ width: "10%" }} />
                    </tr>
                </thead>
                <tbody id="myTable">
                    {proformaList.length > 0 ? proformaList.map((data, i) => (
                        <tr>
                            <td>{data.ProformaInvoiceNo}</td>
                            <td>{data.CompanyName}</td>
                            <td>{moment(data.ProformaInvoiceDate).format('DD-MMM-yyyy')}</td>
                            <td>{data.Service}</td>
                            <td>{data.TaxableAmount?.toLocaleString('en-US')}</td>
                            <td>{data.Tax_Type}</td>
                            <td>{data.CGST?.toLocaleString('en-US')}</td>
                            <td>{data.SGST?.toLocaleString('en-US')}</td>
                            <td>{data.IGST?.toLocaleString('en-US')}</td>
                            <td>{data.Total_Payable?.toLocaleString('en-US')}</td>
                            <td>{data.Outstanding?.toLocaleString('en-US')}</td>
                            <td className="text-center" style={{ width: '5%' }}>
                                {DownloadAccess && <>
                                    <a
                                        // href="javascript:void(0);"
                                        onClick={(e) => this.onProformaDownload(e, data.MemberID)}
                                        title="View Invoice"
                                        className="load_document_icon mx-2"
                                        data-toggle="modal"
                                        data-target="#add_comment_modal"
                                    >
                                        <i className="fa fa-eye" />
                                    </a>
                                </>}
                                {SendAccess && <>
                                    {(JSON.parse(sessionStorage.getItem('loginDataSS')).RoleName == 'Super Admin' || JSON.parse(sessionStorage.getItem('loginDataSS')).RoleName == 'Admin') ? <>
                                        <a
                                            href="javascript:void(0);"
                                            title="Send"
                                            onClick={() => this.shareProforma(data.MemberID, data.ProformaInvoiceNo, data.ContactPersonName, data.EmailAddress)}
                                            className="load_document_icon  p-1 pb-2 px-2 send_credentials-btn mx-1"
                                            data-toggle="modal"
                                            data-target="#add_comment_modal"
                                        >
                                            Send
                                        </a> </> : <></>}
                                </>}
                            </td>

                        </tr>
                    )) : (
                        <tr>
                            <td colSpan={12}> No Record Found</td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }
    toggleFilterCollapse() {
        this.setState((prevstate) => ({
            isFilterShow: !prevstate.isFilterShow
        }))
    }
    shareProforma(MemberID, ProformaInvoiceNo) {
        this.setState({ isLoading: true })
        this.props
            .share_proforma_action(MemberID, ProformaInvoiceNo)
            .then((data) => {
                console.log(data)
                if (data.error != 1) {
                    this.setState({ isLoading: false }, () => toastSuccess(data.data))
                } else {
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear();
                        this.props.navigate("/");
                        setTimeout(() => {
                            toastError(data.msg);
                        }, 2000);
                    } else {
                        toastError(data.data);
                    }
                    this.setState({ isLoading: false })
                    toastError(data.data.ErrorMsg);
                }
            }).catch((e) => {
                console.log(e);
                this.setState({ isLoading: false });
            });
    }
    render() {
        const { isLoading, CompanyName, currentPage, proformaList, isFilterShow,
            ProformaInvoiceDate, ProformaInvoiceNo,
            FullAccess, ReadAccess, WriteAccess, UpdateAccess, DeleteAccess, DownloadAccess, Is_SpecialAccess, SendAccess, recordsPerPage } = this.state
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
        const currentRecords = proformaList.slice(
            indexOfFirstRecord,
            indexOfLastRecord
        );
        const nPages = Math.ceil(proformaList.length / recordsPerPage);
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                    // <></>
                ) : (
                    null
                )}
                {/* <ToastContainer />. */}
                <Header />
                <ToastContainer />
                <section class="registration_form">
                    <div class="container">
                        <div class="row mt-15">
                            <section className="table_section">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-12 col-sm-12 col-lg-12">
                                            <div className="card shadow-none border mb-2" >
                                                <div className="card-header py-2">
                                                    <h6 className='pt-2' style={{ float: 'left' }}>Proforma Invoice</h6>
                                                    {(JSON.parse(sessionStorage.getItem('loginDataSS'))?.RoleName == 'Super Admin' || JSON.parse(sessionStorage.getItem('loginDataSS'))?.RoleName == 'Admin') ? <>
                                                        <a style={{ float: 'right' }}
                                                            href="javascript:void(0);"
                                                            className="btn btn-purple custom_btn"
                                                            title="Filter"
                                                            data-toggle="modal"
                                                            data-target="#filter_modal"
                                                            onClick={() => this.toggleFilterCollapse()}
                                                        >
                                                            <i className="fa fa-filter" />
                                                        </a>

                                                    </> : <></>}
                                                </div>
                                                <ul className="list-group list-group-flush" >
                                                    {isFilterShow && <>

                                                        <li className="list-group-item"><div className="row">
                                                            <div class="col-md-3">
                                                                <div class="form-group">
                                                                    <label>Proforma Invoice No<span className="red-star text-danger">*</span></label>
                                                                    <input type="text" class="form-control" placeholder="Enter Proforma No" value={ProformaInvoiceNo} onChange={(e) => this.setState({ ProformaInvoiceNo: e.target.value })} maxLength={1000} />

                                                                </div>
                                                            </div>
                                                            <div class="col-md-3">
                                                                <div class="form-group">
                                                                    <label>Company Name<span className="red-star text-danger">*</span></label>
                                                                    <input type="text" class="form-control" placeholder="Enter Company name" value={CompanyName} onChange={(e) => this.setState({ CompanyName: e.target.value })} maxLength={1000} />

                                                                </div>
                                                            </div>
                                                            <div class="col-md-3">
                                                                <div class="form-group">
                                                                    <label>Proforma Invoice Date<span className="red-star text-danger">*</span></label>
                                                                    <input type="date" class="form-control" placeholder="Enter Proforma" value={ProformaInvoiceDate} onChange={(e) => this.setState({ ProformaInvoiceDate: e.target.value })} maxLength={1000} />

                                                                </div>
                                                            </div>

                                                            <div className="col-xl-2 mb-3">
                                                                < button style={{ marginTop: '20px' }} className='btn btn-primary mr-2' onClick={() => this.getProformaList()}>
                                                                    Search
                                                                </button>
                                                                <button type="button" style={{ marginTop: '20px' }} className='btn btn-dark mr-2 ms-2' onClick={e => this.clearFilter()}>
                                                                    Clear
                                                                </button>
                                                            </div>
                                                        </div></li>
                                                    </>}
                                                </ul>
                                            </div>

                                            <div className="card shadow-none border">
                                                <div className="card-body p-2 pb-0">

                                                    <div className="custom_table">
                                                        <div className="hack1">
                                                            <div className="hack2">
                                                                {this.proformaRecord(currentRecords)}
                                                                {proformaList.length > 0 ? (
                                                                    <Pagination
                                                                        nPages={nPages}
                                                                        currentPage={currentPage}
                                                                        setCurrentPage={this.updateItem}
                                                                        totalRecords={proformaList.length}
                                                                        pageLength={recordsPerPage}
                                                                        setPageLength={this.updateRecordsPerPage}
                                                                    />
                                                                ) : (
                                                                    <></>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>

                        </div>

                    </div >
                </section >
                {/* <Footer /> */}

            </>
        )
    }
}

export default withRouter(connect(null, { fill_action, get_proformaList_action, proformaInvoiceRpt_action, share_proforma_action })(proformaList));
